export default function toStringValues<T extends Record<string, any>>(
  anEnum: T
): T[keyof T][] {
  return Object.keys(anEnum).map((key) => anEnum[key] as T[keyof T])
}
